import GameConsole from '../Components/PlaygroundPage/GameConsole';
import SelectionInput from '../Components/Portfolio/SelectionInput';
import BlackJack from '../media/img/icons/black-jack.png';
import CodeBreaker from '../media/img/icons/terminal.png';
import ScriptScavengers from '../media/img/icons/desert.png';
import '../css/pages/playground.css';
import { motion } from 'framer-motion';
function PlayGround() {
  return(
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4 }}
    >
      <section className="playground f-col">
        <SelectionInput></SelectionInput>
        <div className="f-col">
          <p className="bracket-title">Featured Games</p>
          <div className="flex">
            <a 
              className="game-icon f-col cen" 
              href="https://dave-sommerville.github.io/blackjack/"
              target="_blank" rel="noopener noreferrer"
            >
              <img src={BlackJack}></img>
              <p className="game-text">Blackjack</p>
            </a>
            <a 
              className="game-icon f-col cen" 
              href="https://dave-sommerville.github.io/code-breaker/"
              target="_blank" rel="noopener noreferrer"
            >
              <img src={CodeBreaker}></img>
              <p className="game-text">Code Breaker</p>
            </a>
            <a 
              className="game-icon f-col cen" 
              href="https://dave-sommerville.github.io/script-scavengers/"
              target="_blank" rel="noopener noreferrer"
              >
              <img src={ScriptScavengers}></img>
              <p className="game-text">Script Scavengers</p>
            </a>
          </div>
        </div>
        {/* <div className="splash-btn-wrapper mb-25">
          <h3 className="rec-title">Experimental</h3>
        </div> */}
      </section>
    </motion.div>
  ); 
}
export default PlayGround;